import { DetailItem } from 'app/shared/info-section/item';
import { MultiSelect } from 'app/shared/select';
import { useTagService } from 'hooks/users/tag';
import React, { useEffect, useState } from 'react';

export const TagsInput = ({ disabled = false, value = '', onChange = () => {} }) => {
  const { fetchTags } = useTagService();

  const [tags, setTags] = useState([]);
  const [selected_tags, setSelectedTag] = useState([]);

  useEffect(() => {
    fetchTags().then(({ tags }) => {
      if (!tags || !tags.length) return;

      const parsed_tags = tags.reduce(
        (sac, tag) => ({
          ...sac,
          [tag.code]: {
            value: tag.code,
            label: tag.value
          }
        }),
        {}
      );

      setTags(Object.values(parsed_tags));
      if (value) {
        const query_tags = value.split(',');
        setSelectedTag(query_tags.filter((tag) => parsed_tags[tag]).map((tag) => parsed_tags[tag]));
      }
    });
  }, []);

  useEffect(() => {
    onChange((selected_tags || []).map((tag) => tag.value).join(','));
  }, [selected_tags]);

  return (
    <>
      <DetailItem title="select tag">
        <MultiSelect
          options={tags}
          value={selected_tags}
          isMulti
          onChange={setSelectedTag}
          disabled={disabled}
        />
      </DetailItem>
    </>
  );
};
